// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"cc709371","194":"dce4fe88","260":"daaf2031","509":"7d18938e","668":"ff7e5b36","762":"2ae40606","811":"48d8aaef","902":"32a734fa","973":"b7af226e","983":"08d9eac7"}[chunkId] + ".js";
};